export default __webpack_public_path__ + "static/media/cloud-commerce-logo.74099053.svg";